import { CliError } from "./lib/cli/cli-error";
import { out } from "./lib/output/out";
import { main } from "@/main";

export async function cliEntry() {
  try {
    await main();
  } catch (error: unknown) {
    const failure =
      error instanceof CliError
        ? error
        : new CliError(error instanceof Error ? error.message : String(error));

    out.failure(failure);
    process.exit(failure.exitCode);
  }
}

void cliEntry();
